import React, { Component } from 'react';
import { connect } from 'react-redux';
import Button from '../utility/Button';
import { Formik, Field, ErrorMessage } from 'formik';
import ErrorDisplay from '../utility/ErrorDisplay';
import LottieLoader from '../utility/LottieLoader';
import CustomInput from '../utility/CustomInput';
import Dropdown from '../utility/Dropdown';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import Cookies from 'js-cookie';
import iconPax from '../../images/icons/icon_32_noofpax.png';
import iconDriver from '../../images/icons/icon_driver.png';
import { withTranslation } from 'react-i18next';
import { validateEnglishOnly, validateIC, validateMobileNo } from '../../js/validators';
import Notification from '../utility/Notification';
import { Helmet } from 'react-helmet';

import {
  fetchMyBookingCompanions,
  doUpdateMyBookingCompanions,
} from '../../actions/myBookings';

import {
  clearApiError,
} from '../../actions/api';

import {
  SITE_TITLE,
  NOTIFICATION_DURATION as notificationDuration,
} from '../../constants';

import { tShirtSizes as sizes } from '../../constants';

class EditCompanions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      initData: false,
      showNotification: false,
    };
    this.initData = this.initData.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.doShowNotification = this.doShowNotification.bind(this);
  }

  componentDidMount() {
    this._isMounted = true;
    this.props.clearApiError();
    this.initData();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  async initData() {
    const { fetchMyBookingCompanions, match } = this.props;
    const uuid = match.params.slug;
    await fetchMyBookingCompanions(uuid);
    const { error, companions } = this.props;
    if(!error && this._isMounted) {
      for(let companion of companions) {
        const id = companion.id;
        this.initialValues = {
          ...this.initialValues,
          [`name${id}`]: companion.name || '',
          [`ic${id}`]: companion.nric || '',
          [`mobile${id}`]: companion.mobile_no ? companion.mobile_no.split('+60')[1] : '',
          [`size${id}`]: companion.tshirt_size || sizes[2],
        };
      }
      this.setState({
        initData: true,
      });
    }
  }

  async submitForm(values) {
    const { doUpdateMyBookingCompanions, companions, match } = this.props;
    const mobPrefix = '+60';
    const uuid = match.params.slug;
    const companionsFormData = companions.map((companion) => {
      const id = companion.id;
      return {
        id: id,
        name: values[`name${id}`],
        mobile_no: mobPrefix.concat(values[`mobile${id}`]),
        nric: values[`ic${id}`],
        tshirt_size: values[`size${id}`],
      };
    });
    const formData = {
      companions: companionsFormData,
    };
    await doUpdateMyBookingCompanions(
      uuid,
      JSON.stringify(formData),
      decodeURIComponent(Cookies.get('XSRF-TOKEN')),
    ).then(() => {
      if(this.props.updateMessage && !this.state.showNotification) {
        this.doShowNotification();
      }
    });
  }

  doShowNotification() {
    window.scrollTo(0, 0);
    this.setState({
      showNotification: true,
    }, () => {
      setTimeout(() => {
        if(this._isMounted) {
          this.setState({
            showNotification: false,
          });
        }
      }, notificationDuration);
    });
  }

  render() {
    const { initData, showNotification } = this.state;
    const { error, companions, updateMessage, loading, t } = this.props;
    if(error) {
      return (
        <ErrorDisplay error={error} />
      );
    }
    if(!initData) {
      return (
        <>
          <LottieLoader />
        </>
      );
    }
    return (
      <>
        <Helmet>
          <title>{t('form:editDetails')} | { SITE_TITLE }</title>
        </Helmet>
        {loading ?
          <LottieLoader /> :
          null}
        <div className={`fe-booking-companions ${loading ? 'fe-hide' : ''}`}>
          <div className="container">
            <div className="row">
              <div className="col-lg-9">
                <h1 className="fe-heading">{t('form:editDetails')}</h1>
                <Notification show={showNotification}>
                  { updateMessage }
                </Notification>
                <Formik
                  validateOnChange={true}
                  validateOnBlur={true}
                  initialValues={this.initialValues}
                  onSubmit={(values) => {
                    this.submitForm(values);
                  }}
                >
                  {({ errors, values, handleSubmit, handleChange }) => (
                    <form
                      noValidate
                      onSubmit={ handleSubmit }
                      className="fe-form"
                    >
                      {companions.map((companion) => {
                        const id = companion.id;
                        const isDriver = companion.is_driver;
                        const nameStr = 'name' + id;
                        const icStr = 'ic' + id;
                        const mobileStr = 'mobile' + id;
                        const sizeStr = 'size' + id;
                        return (
                          <fieldset key={id}>
                            <div className="fe-form-inner">
                              <header className="fe-form-companion-header">
                                <img src={isDriver ? iconDriver : iconPax} alt=""/>
                                <h2>{isDriver ? t('gen:driver') : t('gen:companion')}</h2>
                              </header>
                              <div className={'fe-form-field'}>
                                <label htmlFor={nameStr}>{t('form:fullNameAsIC')}</label>
                                <Field
                                  type="text"
                                  name={nameStr}
                                  validate={validateEnglishOnly}
                                  component={CustomInput}
                                />
                              </div>
                              {/* <div className="fe-form-field">
                                <label htmlFor={sizeStr}>{t('form:tShirtSize')}</label>
                                <Dropdown
                                  name={sizeStr}
                                  value={ values[sizeStr] }
                                  customOnChange={false}
                                  onChange={ handleChange }
                                  options={sizes}
                                />
                              </div> */}
                              <div className="fe-form-field">
                                <label htmlFor={icStr}>{t('form:icNo')}</label>
                                <Field
                                  type="text"
                                  name={icStr}
                                  validate={validateIC}
                                  component={CustomInput}
                                  numbersOnly
                                />
                              </div>
                              <div className="fe-form-field">
                                <label htmlFor={mobileStr}>{t('form:mobileNo')}</label>
                                <div className="fe-form-field-mobile">
                                  <div className="fe-form-mob-prefix">+60</div>
                                  <Field
                                    type="text"
                                    name={mobileStr}
                                    validate={validateMobileNo}
                                    component={CustomInput}
                                    showError={false}
                                    numbersOnly
                                  />
                                </div>
                                <span className="fe-form-error"><ErrorMessage name={mobileStr} render={msg => t(`error:${msg}`)}/></span>
                              </div>
                            </div>
                          </fieldset>
                        );
                      })}
                      <div className="fe-form-message">
                        {t('trip:editCompanionCutoff')}
                      </div>
                      <div className="fe-form-buttons no-margin">
                        {!showNotification ?
                          <Button
                            type="submit"
                          >
                            {t('form:submit')}
                          </Button> : null}
                      </div>
                      <span className="fe-form-error">{ Object.entries(errors).length > 0 ? t('error:incompleteForm') : '' }</span>
                    </form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

EditCompanions.propTypes = {
  error: PropTypes.object,
  loading: PropTypes.bool.isRequired,
  clearApiError: PropTypes.func.isRequired,
  fetchMyBookingCompanions: PropTypes.func.isRequired,
  match: PropTypes.object.isRequired,
  companions: PropTypes.array.isRequired,
  doUpdateMyBookingCompanions: PropTypes.func.isRequired,
  updateMessage: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
};

const mapStateToProps = ({ myBookingsState, apiState }) => ({
  error: apiState.error,
  loading: myBookingsState.loading,
  companions: myBookingsState.companions,
  updateMessage: myBookingsState.updateMessage,
});

const mapDispatchToProps = {
  fetchMyBookingCompanions,
  doUpdateMyBookingCompanions,
  clearApiError,
};

export default withRouter(withTranslation()(connect(mapStateToProps, mapDispatchToProps)(EditCompanions)));
